import InternalRequestStatusHint from 'domains/internal-request/components/internal-request-status-hint'
import OutboundInternalRequestsApiV2 from 'api/v2/admins/outbound-internal-requests-api-v2'
import { getInternalRequestListUrlState, syncInternalRequestListUrl } from 'domains/internal-request/services/internal-request-list-url-state'
import TitlePage from 'components/atoms/title-page'
import { ALERT_TYPES } from 'constants/alert-constants'
import { ONGOING_STATUS } from 'domains/internal-request/constants'
import InternalRequestTable from 'domains/internal-request/organisms/table'
import PropTypes from 'prop-types'
import React, { useCallback, useState } from 'react'
import { useHistory, useLocation } from 'react-router'
import { Card, CardBody } from 'reactstrap'

const propTypes = {
  pageUtils: PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  })
}

const InternalRequestRequestorOngoingListPage = ({ pageUtils }) => {
  const [ internalRequests, setInternalRequests ] = useState([])
  const [ pagination, setPagination ]             = useState({})
  const history                                   = useHistory()
  const location                                  = useLocation()
  const initialUrlState                           = getInternalRequestListUrlState(location.search)
  const [ isLoading, setIsLoading ]               = useState(true)

  const handleFetchInternalRequests = useCallback(async (tableState) => {
    syncInternalRequestListUrl({
      history,
      pathname      : window.location.pathname,
      currentSearch : window.location.search,
      tableState
    })

    setIsLoading(true)

    let additionalFilters = {}

    const statusFilter = tableState.filters.find((filter) => filter.id === 'status')

    if (!statusFilter || statusFilter?.value?.length === 0) {
      additionalFilters = {
        status: Object.values(ONGOING_STATUS)
      }
    }

    await OutboundInternalRequestsApiV2.index({ tableState, additionalFilters })
      .then((response) => {
        setInternalRequests(response.data.internal_requests)
        setPagination(response.data.meta)
      })
      .catch((error) => {
        pageUtils.setApiErrorMsg(error.response.data, ALERT_TYPES.DANGER)
      })
      .finally( () => setIsLoading(false) )
  }, [ history, pageUtils ])

  /**
   * Handler to redirect to the particular pages
   * - If selected record status is requested, go to the detail page
   * - If selected record's status is dispatched, go to the receive page
   * @param {object} datum - selected row record
   */
  const handleSelectRow = useCallback((datum) => {
    const { id } = datum
    history.push({
      pathname: `ongoing/${id}`
    })
  }, [ history ])

  return (
    <>
      <TitlePage mainTitle='Internal Requests' subTitle='Ongoing View Only' />
      <Card>
        <CardBody>
          <InternalRequestStatusHint audience='requestor' />
          <InternalRequestTable
            categoryStatus={ ONGOING_STATUS }
            data={ internalRequests }
            pagination={ pagination }
            isLoading={ isLoading }
            initialFilter={ initialUrlState.filters }
            initialPageIndex={ initialUrlState.pageIndex }
            initialPageSize={ initialUrlState.pageSize }
            onFetchData={ handleFetchInternalRequests }
            rowButtonProps={{
              buttonText    : 'View',
              buttonColour  : 'primary',
              onButtonClick : handleSelectRow
            }}
          />
        </CardBody>
      </Card>
    </>
  )
}

InternalRequestRequestorOngoingListPage.propTypes = propTypes

export default InternalRequestRequestorOngoingListPage
